
import store from '@/store';
import { computed, defineComponent, PropType } from 'vue';
import modals, { modalsNames } from '@/utils/modals';

import '@/assets/icons/close-icon.svg?sprite';

export default defineComponent({
  name: 'CommonModal',
  components: {},
  emits: ['closeModal', 'opened'],
  props: {
    visible: Boolean,
    name: {
      type: String as PropType<keyof typeof modalsNames>,
      required: false,
    },
    hideClose: {
      type: Boolean,
      required: false,
      default: false,
    },
    title: {
      type: String,
      default: ' ',
    },
    width: {
      type: Number,
      default: 600,
    },
    isModalPurchases: {
      type: Boolean,
      default: false,
      required: false,
    },
    isModalAllBranches: {
      type: Boolean,
      default: false,
      required: false,
    },
    isModalOpenSupport: {
      type: Boolean,
      default: false,
      required: false,
    },

  },
  setup(props, ctx) {
    const currentModalOpen = computed(() => store.getters.routeStore.currentModalOpen);
    const isOpen = computed(() => currentModalOpen.value === props.name);
    const closeHandler = () => {
      if (typeof props.name === 'string' && modals[props.name]) {
        modals[props.name].closeModal();
      }
      ctx.emit('closeModal');
    };

    return {
      currentModalOpen,
      isOpen,
      closeHandler,
    };
  },
});
